<label id="{{controlName + '-label'}}" [attr.data-testid]="controlName + '-label'" class="prompt-label label-text"
  [class.error-text]="hasError" for="{{controlName}}">{{label}}<mm-tooltip *ngIf="displayInlineTooltip"
    [position]="tooltip?.position || 'right'" [containsLink]="tooltip?.containsLink || false"
    id="{{controlName + '-tooltip'}}" [textTooltip]="true">
    <tooltip-content>
      <span [innerText]="tooltip?.content"></span>
    </tooltip-content>
    <tooltip-trigger-element>
      <span [innerText]="tooltip?.inlineText"></span>
    </tooltip-trigger-element>
  </mm-tooltip>{{tooltip?.postInlineTooltipText}}</label>

<span *ngIf="hasGreyText" class="label-text" id="label-greytext"
  [attr.data-testid]="controlName + '-greytext'">{{greyText}}</span>

<mm-tooltip *ngIf="displayIconTooltip" [position]="tooltip?.position || 'right'"
  [containsLink]="tooltip?.containsLink || false" id="{{controlName + '-tooltip'}}">
  <tooltip-content *ngIf="tooltip?.content">
    <span [attr.data-testid]="controlName + '-tooltip-content'" [innerText]="tooltip?.content"></span>
  </tooltip-content>
  <tooltip-content *ngIf="tooltip?.html && !tooltip?.content">
    <span [attr.data-testid]="controlName + '-tooltip-html'" [innerHtml]="tooltip?.html"></span>
  </tooltip-content>
  <tooltip-trigger-element>
    <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
  </tooltip-trigger-element>
</mm-tooltip>
<span *ngIf="hasSecondLineGreyText" class="label-text"
  [ngClass]="!hasSecondLineGreyTextLink ? 'label-text' : 'label-text-with-link'" id="label-greytext-secondline"
  [attr.data-testid]="controlName + '-greytext-secondline'">{{secondLineGreyText?.text}} <a
    *ngIf="hasSecondLineGreyTextLink" (click)="onClickHyperLink()" [attr.data-testid]="controlName + '-hyperLink'">{{secondLineGreyText?.linkText}}</a></span>